class WorkbookHelper {
    isRootDrilldownLevel: KnockoutComputed<boolean>;
    //To help changing active tab for drilldown operations
    activeToolbarTab: KnockoutObservable<number>;
    workbookConfig: WorkbookConfig;
    workbookTabsDataSource: KnockoutObservableArray<WorkbookTabDataSourceVM>;
    workbookTabsSelectedIndex: KnockoutObservable<number>;
    applyFiltersDisabled: KnockoutObservable<boolean>;
    showHideFilterActions: KnockoutComputed<boolean>;
    private _showHideFilterActions: KnockoutObservable<boolean>;
    private firstTab: boolean = true;

    workbookTabsPanelResize: () => void;

    constructor(data: any, workbookConfig: WorkbookConfig) {
        this.workbookConfig = workbookConfig;
        this.applyFiltersDisabled = ko.observable(true);
        
        this._showHideFilterActions = ko.observable(this.workbookConfig?.generalSettings?.editing() ?? false);
        this.showHideFilterActions = ko.pureComputed({
            read: function (this: WorkbookHelper) {
                return isTouchDevice() ? this._showHideFilterActions() : true;
            },
            write: function (this: WorkbookHelper, value: boolean) {
                this._showHideFilterActions(value);
            },
        }, this);

        this.activeToolbarTab = ko.observable(0);
        
        if (workbookConfig) {
            this.isRootDrilldownLevel = ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                return this()?.drilldownManager?.activeDrilldownIndex() == 0;
            }, workbookConfig.activeTabOrWidget);

            this.workbookTabsDataSource = ko.observableArray(this.getWorkbookTabsDataSource());
            this.workbookTabsSelectedIndex = ko.observable(0);
        }
    }

    goToDrilldownToolbarTab() {
        Ir.Components.Workbook.ToolBarTab.goToDrilldownTab();
    }

    addTab(tabType: TabTypeEnum, reportStub: ReportStub, widgetId: number = null) {
        let isEmptyReport = reportStub.id === NewReportStubTypeEnum.Empty;
        let isDesignReport = reportStub.id === NewReportStubTypeEnum.Chart || reportStub.id === NewReportStubTypeEnum.Report || reportStub.id === NewReportStubTypeEnum.Pivot;

        let o = {
            url: urlConfigs.tabs + "AddTab",
            data: {
                workbookId: this.workbookConfig.workbookId(),
                tabType: tabType,
                newReportId: isEmptyReport || isDesignReport ? 0 : reportStub.id,
                widgetId: widgetId,
                newReportType: reportStub.type
            },
            dataType: "json",
            async: false,

        } as RequestServerParams;
        o.successFunction = function (this: WorkbookHelper, data, e) {
            let newTab = new WorkbookTab(data.tab, this.workbookConfig);
            this.workbookConfig.tabs.push(newTab);

            let newTabDataSource = new WorkbookTabDataSourceVM({
                iconClass: newTab.tabType() === TabTypeEnum.Dashboard ? "mi" : "ms",
                title: newTab.name(),
                tab: newTab,
                order: this.workbookConfig.workbookHelper.workbookTabsDataSource().length + 1
            });

            Ir.Components.Workbook.WorkbookTabs.addTab(newTabDataSource, this);
            if (isDesignReport) {
                Ir.Components.ReportDesigner.ReportDesigner.showEditor(this.workbookConfig.activeTab());
            }

        }.bind(this);
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to create workbook tab`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }
    cloneTabs(tabs: Array<{ tabId: number, name: string, order: number }>): Array<{ tab: WorkbookTab, tabDataSource: WorkbookTabDataSourceVM }> {
        let clonedTabs: Array<{ tab: WorkbookTab, tabDataSource: WorkbookTabDataSourceVM }> = []
        if (tabs.length === 0) {
            return clonedTabs;
        }

        let o = {
            url: urlConfigs.tabs + "CloneTabs",
            data: {
                workbookId: this.workbookConfig.workbookId(),
                tabs: tabs
            },
            dataType: "json",
            async: false,

        } as RequestServerParams;
        o.successFunction = function (this: WorkbookHelper, data, e) {
            data.tabs.forEach((x) => {
                let newTab = new WorkbookTab(x, this.workbookConfig);
                let newTabDataSource = new WorkbookTabDataSourceVM({
                    //icon: this.getTabIcon(newTab.tabType(), newTab.widgetType()),
                    iconClass: newTab.tabType() === TabTypeEnum.Dashboard ? "mi" : "ms",
                    title: newTab.name(),
                    tab: newTab,
                    order: newTab.order
                });

                clonedTabs.push({ tab: newTab, tabDataSource: newTabDataSource });
            });            
        }.bind(this);
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to clone workbook tab`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);

        return clonedTabs;
    }

    removeTab(tabId: number) {
        if (this.workbookConfig.tabs().length === 1) {
            DevExpress.ui.notify(`Cannot delete the last tab. Create a new tab first or delete the workbook.`);
            return;
        }

        let o = {
            url: urlConfigs.tabs + "RemoveTab",
            data: { workbookId: this.workbookConfig.workbookId(), tabId: tabId },
            dataType: "json",
            async: false,

        } as RequestServerParams;
        o.successFunction = function (this: WorkbookHelper, data, e) {
            let tab = this.workbookConfig.tabs().find(x => x.id() === tabId);
            this.workbookConfig.tabs.remove(tab);

            let tabDS = this.workbookConfig.workbookHelper.workbookTabsDataSource().find(x => x.tab().id() === tabId);
            this.workbookConfig.workbookHelper.workbookTabsDataSource.remove(tabDS);
        }.bind(this);
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to remove workbook tab`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    getTab(tab: WorkbookTab, content: any = null) {
        let self = this;
        IrUtils.showLoadPanel();

        let config = this.workbookConfig;

        let submitObject = {
            tabId: tab.id(),
            workbookId: config.workbookId(),
            resetDrilldown: workbook.workbookConfig.isPrinting || workbook.workbookConfig.isExcelPrinting ? false : true,
        } as any;

        if (tab.detailingWidget.hasDetailing()) {
            tab.detailingWidget.setSubmitObj(submitObject, tab);
        }

        let $div = $(`<div style="height: 100%;"></div>`);
        if (tab.tabContent) {
            tab.tabContent.replaceWith($div);
        }
        tab.tabContent = $div;

        let tabPageContainer = $(`<div class="new-tab-container" style="height: 100%;">`);
        ko.applyBindings(tab, tabPageContainer[0]);

        $div.append(tabPageContainer);

        if (tab.tabType() === TabTypeEnum.Dashboard) {
            let $dashboard = $(`<dashboard params="config: config"></dashboard>`);
            ko.applyBindings({ config }, $dashboard[0]);
            tabPageContainer.append($dashboard);
            IrUtils.hideLoadPanel();
            return $div;
        }

        let o = {
            url: urlConfigs.tabs + "GetTab",
            data: submitObject,
            dataType: "json",
            async: true
        } as RequestServerParams;
        o.successFunction = function (data, e) {
            if (data.filters) {
                let filtersVM = createInstances(Filter, data.filters as Array<any>);
                tab.filters(filtersVM);
            }

            let $drilldownMultiView = $(`<drilldown-multiview params="config: config, result: result"></drilldown-multiview>`);
            ko.applyBindings({ config, result: data }, $drilldownMultiView[0]);
            tabPageContainer.append($drilldownMultiView);

            IrUtils.hideLoadPanel();

            setTimeout(function () {
                Ir.Components.Workbook.ToolBar.ReportToolBar.repaintToolbar();
                if (self.firstTab) {
                    self.firstTab = false;
                    self.workbookConfig.callIntroForEmptyWorkbook();
                }
            }, 150);
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to get workbook tab`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        if (content) {
            o.successFunction(content, null);
        }
        else { 
            irGlobal.requestServer(o);
        }

        return $div;
    }

    getWorkbookTabsDataSource(): Array<WorkbookTabDataSourceVM> {
        let tabsList = [];
        for (let tab of this.workbookConfig.tabs()) {
            tabsList.push(new WorkbookTabDataSourceVM({
                //icon: this.getTabIcon(tab.tabType(), tab.widgetType()),
                iconClass: tab.tabType() === TabTypeEnum.Dashboard ? "mi" : "ms",
                title: tab.name(),
                tab: tab
            }));
        }
        return tabsList;
    }

    getTabIcon(tabType: TabTypeEnum, widgetType: WidgetType, forDashboardWidget = false) {
        switch (tabType) {
            case TabTypeEnum.Chart:
            case TabTypeEnum.ChartDesigner:
                return "equalizer";
            case TabTypeEnum.Dashboard:
                if (forDashboardWidget) {
                    switch (widgetType) {
                        case WidgetType.Report:
                            return "list_alt";
                        case WidgetType.Chart:
                            return "equalizer";
                        case WidgetType.Pivot:
                            return "pivot_table_chart";
                    }
                    return "list_alt";
                }
                else {
                    return "dashboard";
                }
            case TabTypeEnum.Report:
            case TabTypeEnum.ReportDesigner:
                switch (widgetType) {
                    case WidgetType.Pivot:
                        return "pivot_table_chart";
                }
                return "list_alt";
        }
    }

    save() {
        let o = {
            url: urlConfigs.tabs + "SaveWorkbook",
            data: {
                workbookId: this.workbookConfig.workbookId(),
                activeTabId: this.workbookConfig.activeTab().id()
            },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (data: {
            hasNewIds: boolean,
            workbookId: number,
            tabs: Array<{
                tabId: number,
                tabType: TabTypeEnum,
                dashboardId: number,
                widgets: Array<{ widgetId: number }>
            }>
        }) {

            if (data.hasNewIds) {
                workbook.workbookConfig.workbookId(data.workbookId);
                for (var i = 0; i < workbook.workbookConfig.tabs().length; i++) {
                    let tab = workbook.workbookConfig.tabs()[i];
                    tab.id(data.tabs[i].tabId);

                    if (tab.tabType() == TabTypeEnum.Dashboard && tab.isDashboardLoaded) {
                        for (var w = 0; w < tab.dashboard.widgets().length; w++) {
                            let widget = tab.dashboard.widgets()[w];
                            widget.id(data.tabs[i].widgets[w].widgetId);
                        }
                    }
                }

                window.history.replaceState("", "", `${urlConfigs.tabs}edit/${workbook.workbookConfig.workbookId()}`);
            }

            DevExpress.ui.notify(`Workbook saved successfully`);
        }.bind(this);
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to save workbook`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }
    saveTabsOrder() {
        let sortedTabs = this.workbookConfig.tabs().slice().sort((a, b) => a.order() - b.order());
        let o = {
            url: urlConfigs.tabs + "SaveTabsOrder",
            data: {
                workbookId: this.workbookConfig.workbookId(),
                tabs: sortedTabs.map(x => x.id())
            },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to save workbook tab order`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }
    setDefaultWorkbook() {
        let o = {
            url: urlConfigs.tabs + "UpdateDefaultWorkbook",
            data: {
                workbookId: this.workbookConfig.workbookId()
            },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (this: WorkbookHelper, data) {
            this.workbookConfig.defaultWorkbook(data);
            DevExpress.ui.notify(data ? `'${this.workbookConfig.workbookName}' workbook set as default` : `'${this.workbookConfig.workbookName}' workbook unset as default`);
        }.bind(this);
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to save default workbook`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    showShareWorkbook(workbookId: number) {
        let saveFunction: () => boolean = null
        const popup = $('#workbookSharePopup').dxPopup({
            contentTemplate: () => {
                let vm = {
                    access: [],
                    popup: popup,
                    workbookId: workbookId,
                    callback: function (obj) {
                        saveFunction = obj.save;
                    }
                };

                let o = {
                    url: urlConfigs.tabs + "GetWorkbookAccess",
                    data: { workbookId: workbookId },
                    dataType: "json",
                    async: false
                } as RequestServerParams;
                o.successFunction = function (data, e) {
                    vm.access = data.access;
                }.bind(this);
                o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
                    errorItem.userMessage = `Failed to get workbook accesses`;
                    irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                };

                irGlobal.requestServer(o);

                let $div = $(`<workbookshare params="access: $data.access, popup: $data.popup, workbookId: $data.workbookId, callback: $data.callback"></workbookshare>`);
                ko.applyBindings(vm, $div[0]);
                return $div;
            },
            maxWidth: "100%",
            width: isMobile() ? 400 : 800,
            height: 500,
            maxHeight: "100%",
            container: 'body',
            showTitle: true,
            title: 'Workbook Access',
            visible: false,
            hideOnOutsideClick: true,
            showCloseButton: true,
            toolbarItems: [{
                    widget: 'dxButton',
                    toolbar: 'bottom',
                    location: 'after',
                    options: {
                        icon: 'save',
                        stylingMode: 'contained',
                        text: 'Save',
                        type: 'default',
                        onClick() {
                            if (saveFunction()) {
                                popup.hide();
                            }
                        }
                    }
                }, {
                    widget: 'dxButton',
                    toolbar: 'bottom',
                    location: 'after',
                    options: {
                        text: 'Close',
                        icon: 'remove',
                        stylingMode: 'outlined',
                        type: 'normal',
                        onClick() {
                            popup.hide();
                        },
                    },
                }],
        }).dxPopup('instance');
        popup.show();
    }
    showCopyWorkbook() {
        let saveFunction: () => boolean = null;

        let o = {
            url: urlConfigs.tabs + "copyWorkbookName",
            data: {
                workbookId: this.workbookConfig.workbookId(),
                workbookName: "",
                copyScheduledEmails: false,
                save: false,
                tabs: []
            },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (data) {
            let popup = $('#copyWorkbookPopup').dxPopup({
                contentTemplate: function () {
                    let element = $(`<workbookcopy params="workbookName: $data.workbookName, tabWidgetDependencies: $data.tabWidgetDependencies, callback: $data.callback"></workbookcopy>`);
                    ko.applyBindings({
                        workbookName: data.name,
                        tabWidgetDependencies: data.tabWidgetDependencies,
                        callback: function (obj) {
                            saveFunction = obj.save;
                        }
                    }, element.get(0));
                    return element;
                }.bind(this),
                width: 400,
                height: 385,
                showTitle: true,
                title: 'Save Workbook',
                visible: false,
                hideOnOutsideClick: false,
                onShown: function () {
                    $(".dx-overlay-wrapper").css("z-index", "1049");
                },
                toolbarItems: [
                    {
                        widget: 'dxButton',
                        toolbar: 'bottom',
                        location: 'after',
                        options: {
                            icon: 'save',
                            stylingMode: 'contained',
                            type: 'default',
                            text: 'Save',
                            onClick(e) {
                                if (saveFunction()) {
                                    popup.hide();
                                }
                            },
                        },
                    }, {
                        widget: 'dxButton',
                        toolbar: 'bottom',
                        location: 'after',
                        options: {
                            text: 'Close',
                            icon: 'remove',
                            stylingMode: 'outlined',
                            type: 'normal',
                            onClick(e) {
                                popup.hide();
                            },
                        },
                    }
                ],
            } as DevExpress.ui.dxPopup.Properties).dxPopup('instance');
            popup.show();
        }.bind(this);
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to copy workbook`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }
    showWorkbookInfo() {
        const popup = $('#workbookInfoPopup').dxPopup({
            contentTemplate: () => {
                let $div = $(`<workbookinfo></workbookinfo>`);
                ko.applyBindings({}, $div[0]);
                return $div;
            },
            maxWidth: "100%",
            width: 600,
            maxHeight: "100%",
            height: 500,
            container: '#newworkbookpage',
            showTitle: true,
            title: 'Workbook',
            visible: false,
            hideOnOutsideClick: true,
            showCloseButton: true,
        }).dxPopup('instance');
        popup.show();
    }
    showSQL() {
        if (workbook.workbookConfig.generalSettings.editing() && loggedUser.permissions.viewSQL()) {
            let items = [];
            let name = workbook.workbookConfig.activeTabOrWidget().name();
            if (workbook.workbookConfig.activeTabOrWidget().tabOrWidget == TabOrWidgetEnum.Tab && workbook.workbookConfig.activeTab().tabType() === TabTypeEnum.Dashboard) {
                items.push({ name, sql: "Select a widget first." });
            }
            else {
                let drilldownManager = workbook.workbookConfig.activeTabOrWidget().drilldownManager;
                let sql = drilldownManager.drilldownViewList()[drilldownManager.activeDrilldownIndex()].widget().result.sql;
                items.push({ name, sql });
            }
            const popup = $('#workbookSQLPopup').dxPopup({
                contentTemplate: () => {

                    let dataSource = items.map(function (item) {
                        return {
                            title: item.name,
                            template: function () {
                                return $(`<textarea class="form-control sqlText" aria-label="With textarea">${item.sql}</textarea>`).css("height", "100%");
                            }
                        }
                    });
                    return $("<div class='sqlText-tabPanel'>").dxTabPanel({
                        dataSource: dataSource,
                        selectedIndex: 0,
                        width: '100%',
                        height: '100%',
                    });
                },
                maxWidth: "100%",
                width: 600,
                maxHeight: "100%",
                height: 500,
                container: 'body',
                showTitle: true,
                title: 'Diagnostic SQL',
                visible: false,
                hideOnOutsideClick: true,
                showCloseButton: true,
            }).dxPopup('instance');
            popup.show();
        }
    }
    showMoveOrCopyTab(tabId: number) {
        let saveFunction: () => boolean = null;
        let element = $(`#workbookMoverCopyTabPopup`);
        if (!element.length) {
            element = $("<div id='workbookMoverCopyTabPopup'></div>").appendTo('body');
        }

        const popup = element.dxPopup({
            contentTemplate: () => {
                let vm = {
                    popup: popup,
                    tabId: tabId,
                    callback: function (obj) {
                        saveFunction = obj.save;
                    }
                }

                let $div = $(`<workbooktab-movecopy params="popup: $data.popup, tabId: $data.tabId, callback: $data.callback"></workbooktab-movecopy>`);
                ko.applyBindings(vm, $div[0]);
                return $div;
            },
            width: 400,
            height: 400,
            container: 'body',
            showTitle: true,
            title: 'Move or Copy',
            visible: false,
            hideOnOutsideClick: true,
            showCloseButton: true,
            toolbarItems: [{
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    icon: 'save',
                    stylingMode: 'contained',
                    type: 'default',
                    text: 'Save',
                    onClick() {
                        if (saveFunction()) {
                            popup.hide();
                        }
                    }
                },
            }, {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: 'Close',
                    icon: 'remove',
                    stylingMode: 'outlined',
                    type: 'normal',
                    onClick() {
                        popup.hide();
                    }
                },
            }],
        }).dxPopup('instance');
        popup.show();
    }

    showPDFTemplate(callback: (pdfTemplateId: number, landscape: boolean) => void) {
        let confirmFunction: () => { pdfTemplateId: number, landscape: boolean } = null;
        let popup = $('#emailPdfTemplate').dxPopup({
            contentTemplate: function () {
                let template = $(`<select-pdftemplate params="callback: $data.callback"></select-pdftemplate>`);
                ko.applyBindings({
                    callback: function (obj) {
                        confirmFunction = obj.confirm;
                    }
                }, template.get(0));
                return template;
            },
            width: 340,
            height: 160,
            showTitle: true,
            title: 'PDF Template',
            visible: false,
            hideOnOutsideClick: false,
            showCloseButton: false,
            onShown: function () {
                $(".dx-overlay-wrapper").css("z-index", "1049");
            },
            toolbarItems: [{
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: 'Confirm',
                    onClick() {
                        let result = confirmFunction();
                        callback(result.pdfTemplateId, result.landscape);

                        popup.hide();
                    }
                }
            }, {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: 'Close',
                    onClick() {
                        popup.hide();
                    }
                }
            }]
        }).dxPopup('instance');

        popup.show();
    }
    exportToXLSXCSV(isCSV: boolean, withoutHeaders: boolean, submitObject, callback: (settings) => void) {
        let o = {
            url: urlConfigs.email + "GetExportDetails",
            data: submitObject,
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (this: WorkbookTab, result, e) {
            let settings = {
                isCSV: isCSV,
                withoutHeaders: withoutHeaders,
                printMessage: result.printMessage,
                mappingName: result.mappingName,
                workbookName: result.workbookName,
                tabName: result.tabName,
                widgetName: result.widgetName,
                reportName: result.reportName,
                groupBy: result.groupingName,
                orderBy: result.orderBy,
                filters: result.filters,
                companyName: result.companyName,
                fontSize: result.fontSize,
                glReport: result.glReport,
                subtotalsPosition: result.subtotalsPosition,
                formattingRules: result.formattingRules,
                currencyCode: result.currencyCode,
                subTotalText: result.subTotalText,
                save: true,
                fileName: result.fileName,
                showReportRowCount: result.showReportRowCount,
                analyzeByTop: result.analyzeByTop,
                groupByTop: result.groupByTop,
                separateFields: result.separateFields
            };

            callback(settings);
        }.bind(this);
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to get details for export to XLSX/CSV`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    goToURL(url: string, name: string, noChangeURLCallback: () => void = null) {
        if (this.workbookConfig.hasPendingChanges) {
            let customDialog = DevExpress.ui.dialog.custom({
                showTitle: false,
                messageHtml: `Are you sure you want to go to ${name}? You have pending changes to your workbook.`,
                buttons: [
                    { text: "Yes", onClick: function () { return true } },
                    { text: "No", onClick: function () { return false } }
                ]
            });
            customDialog.show().done(function (dialogResult) {
                if (dialogResult) {
                    document.location.href = url;
                }
                else {
                    if (noChangeURLCallback) {
                        noChangeURLCallback();
                    }
                }
            });
        }
        else {
            document.location.href = url;
        }
    }

    saveFiltersOrder(filters: Array<Filter>, scope: ContainerScopeEnum) {
        let o = {
            url: urlConfigs.filters + "SaveFiltersOrder",
            data: {
                workbookId: this.workbookConfig.workbookId(),
                tabId: this.workbookConfig.activeTab().id(),
                widgetId: this.workbookConfig.selectedDashboardWidget?.id() ?? 0,
                scope: scope,
                filters: filters.map(x => x.id())
            },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to save filter order`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }
}